import React, { Component } from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'

import { ISO_DATE_FORMAT } from 'Global/constants'

import 'react-datepicker/dist/react-datepicker.css'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'CreateReservationModalContainer'

    static propTypes = {
      addEventOption: PropTypes.func.isRequired,
      close: PropTypes.func.isRequired,
      create: PropTypes.func.isRequired,
      eventOptions: PropTypes.array.isRequired,
      hasError: PropTypes.bool.isRequired,
      isPending: PropTypes.bool.isRequired,
      reservations: PropTypes.array.isRequired,
      rug: PropTypes.object.isRequired,
      user: PropTypes.object.isRequired,
    }

    state = {
      dateFrom: '',
      dateTo: '',
      errors: {
        dates: false,
        event: false,
        reason: false,
      },
      event: '',
      eventOptions: this.props.eventOptions,
      reason: '',
    }

    handleEventItemAdded = (e, { value }) => {
      const { addEventOption } = this.props
      const { eventOptions } = this.state

      const eventOption = { text: value, value }

      this.setState({
        eventOptions: [...eventOptions, eventOption],
      })

      addEventOption(eventOption)
    }

    handleEventChanged = (e, { value }) => {
      const { errors } = this.state

      this.setState({
        errors: {
          ...errors,
          event: false,
        },
        event: value,
      })
    }

    handleEventReset = () => {
      this.setState({ event: '' })
    }

    handleFromPicked = date => {
      const { errors } = this.state

      this.setState({
        dateFrom: date,
        dateTo: '',
        errors: {
          ...errors,
          dates: false,
        },
      })
    }

    handleReasonChanged = (e, { value }) => {
      const { errors } = this.state

      this.setState({
        errors: {
          ...errors,
          reason: false,
        },
        reason: value,
      })
    }

    handleSubmit = e => {
      const { create, rug, user } = this.props
      const { errors, event, dateFrom, dateTo, reason } = this.state

      e.preventDefault()

      const convertedDateFrom = moment(dateFrom, 'DD.MM.YYYY').format(ISO_DATE_FORMAT)
      const convertedDateTo = moment(dateTo, 'DD.MM.YYYY').format(ISO_DATE_FORMAT)

      if (reason.length === 0 && event.length === 0) {
        this.setState({
          errors: {
            ...errors,
            reason: true,
          },
        })
        return
      }

      if (!dateFrom || !dateTo) {
        this.setState({
          errors: {
            ...errors,
            dates: true,
          },
        })
        return
      }

      const reservation = {
        createdBy: user.id,
        dateFrom: convertedDateFrom,
        dateTo: convertedDateTo,
        event,
        reason,
        rug: rug.id,
      }

      create(reservation)
    }

    handleToPicked = date => {
      const { errors } = this.state

      this.setState({
        dateTo: date,
        errors: {
          ...errors,
          dates: false,
        },
      })
    }

    render() {
      return (
        <WrappedComponent
          close={this.props.close}
          dateFrom={this.state.dateFrom}
          dateTo={this.state.dateTo}
          errors={this.state.errors}
          event={this.state.event}
          eventOptions={this.state.eventOptions}
          handleEventChanged={this.handleEventChanged}
          handleEventItemAdded={this.handleEventItemAdded}
          handleEventReset={this.handleEventReset}
          handleFromPicked={this.handleFromPicked}
          handleReasonChanged={this.handleReasonChanged}
          handleSubmit={this.handleSubmit}
          handleToPicked={this.handleToPicked}
          hasError={this.props.hasError}
          isPending={this.props.isPending}
          reason={this.state.reason}
          reservations={this.props.reservations}
        />
      )
    }
  }

  return Container
}
